import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  reportsDataService,
} from 'app/services';
import {
  alerts,
  actionIcon
} from 'app/components/global';
import controller from './edit-report-instance-comment-dialog.controller';
import template from './edit-report-instance-comment-dialog.html';


export class dialogService {
  getOptions($event, { reportInstanceComment }) {
    return {
      controller,
      controllerAs: 'editReportInstanceCommentDialogVM',
      locals: {
        reportInstanceComment
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.reports.editReportInstanceCommentDialog', [
  ssDialogService,
  loaderService,
  reportsDataService,
  alerts,
  actionIcon
])
  .service('editReportInstanceCommentDialog', dialogService)
  .name;

console.log('app.components.reports.editReportInstanceCommentDialog created');
